//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
let d=[[[0,"CurrentString",1,0],[0,"FilterMatchCase",1,0],[0,"FilterWholeWord",1,0],[0,"ReplaceString",1,0],[0,"ReplaceType",1,0],[0,"SearchString",1,0],[0,"UpdateString",1,0]],[[["expressions"],"SetSelectedExpressions",{},1,0]],[]];
SPLM.ReplaceExpressionsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ReplaceExpressionsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ReplaceExpressionsBuilder.ReplacementTypes = Object.freeze({
    "ExpressionName" : "ExpressionName", "GenericString" : "GenericString"});

export default SPLM;